module.exports = __webpack_public_path__ + "static/img/about2.ddf66301.png";